export default "__VITE_ASSET__D3Lm08W$__"